import { FC, ReactNode } from "react";

import styles from "./grid-layout.module.css";
type Props = {
  children: ReactNode[];
  display?: "grid" | "flex";
};

export const GridLayout: FC<Props> = ({ children, display }) => {
  return (
    <div className={`${styles.grid} ${display ? styles[display] : ""}`}>
      {children}
    </div>
  );
};
